import React from "react";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Link } from "react-router-dom";
import { ADMIN_MENU_PATH } from "../../constants/paths";

const DragAndDropColumn = ({ sections, onDragEnd }) => {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided, snapshot) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {sections.map((section, index) => {
              return (
                <Draggable
                  key={section.id}
                  draggableId={section.id}
                  index={index}
                >
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      className="bg-white py-2 px-4 flex mb-4 items-center"
                    >
                      <img
                        src={section.image}
                        className="w-12 h-12 mr-2 rounded-full"
                      ></img>
                      <Link to={`${ADMIN_MENU_PATH}/seccion/${section.id}`}>
                        {section.title}
                      </Link>
                    </div>
                  )}
                </Draggable>
              );
            })}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default DragAndDropColumn;
